<template>
  <div>
    <h1>
      <img width="580" height="227" v-for="(logo, index) in logos" :src="logo" v-show="currentLogo === index" class="logoAnimation">
      <img width="180" height="43" src="./logos/Mobile.svg" class="logoMobile">
      <span>The Longest Shortest Time</span>
    </h1>
  </div>
</template>

<script>
export default {
  name: 'logo',
  data () {
    return {
      currentLogo: 0,
      logos: [
        require('./logos/1.svg'),
        require('./logos/2.svg'),
        require('./logos/3.svg'),
        require('./logos/4.svg'),
        require('./logos/5.svg'),
        require('./logos/6.svg'),
        require('./logos/7.svg'),
        require('./logos/8.svg')
      ]
    }
  },
  mounted () {
    this.cycleLogos()
  },
  methods: {
    cycleLogos () {
      let vm = this
      let interval = setInterval(() => {
        if ((this.currentLogo + 1) >= this.logos.length) {
          vm.currentLogo = 0
          clearInterval(interval)
        } else {
          this.currentLogo++
        }
      }, 600)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  h1
    font-size: 0
    margin-top: 10px
    margin-bottom: 10px
    margin-left: -40px
    +tablet
      margin-right: 50px
      margin-top: -48px
      margin-bottom: -10px
      position: relative
      top: 20px
      width: 375px
      height: 147px
    +smDesktop
      margin-left: -120px
      width: 490px
      height: auto
    +desktop
      margin-left: -160px
      width: 580px
      height: 226px
    img
      max-height: none
      width: 100%
      height: auto
      &.logoMobile
        width: 260px
        height: auto
        +tablet
          display: none
      &.logoAnimation
        display: none
        +tablet
          display: block
    span
      color: transparent
      position: absolute
      height: 0
      overflow: hidden
</style>



// WEBPACK FOOTER //
// Logo.vue?1c0d4305